import ObjectUtils from './ObjectUtilsMixin';
import statusFeedback from '../feedback/StatusFeedbackComponent.vue';

export default {
    components: {
        'status-feedback': statusFeedback,
    },

    mixins: [
        ObjectUtils,
    ],

    data() {

        return {
            // tole je pa en mixin za ajax requeste iz vue :P
            successFeedback: null, // this is set to a generic message when ajax returns code 200 and automatically cleared
            failFeedback: null, // this is set to a generic message when ajax call fails and is automatically cleared
            errors: [], // errors are automatically returned in this array and automatically cleared
            dataItems: [], // this is the list you are working with and needs to be set in the component
            url: '', // url needs to be set in the component
            _createUrl: null,
            _updateUrl: null,
            _deleteUrl: null,
        };

    },

    methods: {

        // use this method to append an object to the end of the list or any other index
        onAdd(object = {}, index = null, callback = null) {

            this._clearMessages();

            if (index < 0 || index === null || index > this.dataItems.length) {
                this.dataItems.push(object);
            } else {
                this.dataItems.splice(index, 0, object);
            }

            if (callback) {
                callback(object);
            }

        },

        // use this method to delete an object from the list and db
        onDelete(item, successCallback = null, failCallback = null) {

            this._clearMessages();
            // delete added object -> not yet saved (no callback)
            if (item.id === null || item.id === undefined) {
                this._spliceDataByObjReference(item);
                return;
            }

            // delete object in db
            this._deleteItem(item, successCallback, failCallback);
        },

        // use this method to create or update an object from the list in db
        onUpdate(item, successCallback = null, failCallback = null) {

            this._clearMessages();

            // create object
            // due to empty rows that can be added into tables, save actions
            // can then call on update
            if (item.id === null || item.id === undefined) {
                this._createItem(item, successCallback, failCallback);
                return;
            }

            // update object in db
            return this._updateItem(item, successCallback, failCallback);

        },

        _deleteItem(item, successCallback, failCallback) {

            let url = (this._deleteUrl || this.url) + `/${item.id}`;

            window.axios.delete(url)
                .then(() => {

                    this._spliceDataByObjReference(item);
                    this._successCallback(item.id, {}, successCallback);

                })
                .catch(error => {
                    this._failCallback(item.id, error, failCallback);
                });
        },

        _createItem(item, successCallback, failCallback) {

            let url = this._createUrl || this.url;

            window.axios.post(url, item)
                .then((response) => {
                    this._spliceDataByObjReference(item, response.data);
                    this._successCallback(response.data.id, response.data, successCallback);
                })
                .catch(error => {
                    this._failCallback(null, error, failCallback);
                });
        },

        _updateItem(item, successCallback, failCallback) {

            let url = (this._updateUrl || this.url) + `/${item.id}`;

            window.axios.patch(url, item)
                .then(response => {
                    this._spliceDataByObjReference(item, response.data);
                    this._successCallback(item.id, response.data, successCallback);
                })
                .catch(error => {
                    this._failCallback(item.id, error, failCallback);
                });
        },

        _successCallback(id, obj, successCallback) {
            this.errors = {};
            this.successFeedback = 'Operation successful!';
            this.failFeedback = null;

            if (successCallback) {
                successCallback(id, obj);
            }

        },

        _failCallback(id, errors, failCallback) {
            this.errors = errors.response.data.errors;
            this.successFeedback = null;
            this.failFeedback = 'Operation failed!';

            if (failCallback) {
                failCallback(id, errors);
            }

        },

        _clearMessages() {
            this.errors = {};
            this.successFeedback = null;
            this.failFeedback = null;
        },

        _spliceDataByObjReference(obj, replaceObj = null) {
            this._spliceByObjReference(this.dataItems, obj, replaceObj);
        },

        _spliceByObjReference(arr, obj, replaceObj) {
            let index = arr.indexOf(obj);
            // let index = this.objectFindInArray(arr, obj);

            if (index !== -1) {
                if (replaceObj) {
                    arr.splice(index, 1, replaceObj);
                } else {
                    arr.splice(index, 1);
                }
            }
        },
    },

};



// WEBPACK FOOTER //
// ./resources/assets/js/components/mixins/AjaxListMixin.js